export const EMAILS_RESOURCE_NAME = 'emails';

// TODO: update based on backend definitions
export const ATTRIBUTE_ENTRY_CONDITIONS = [{
  field: "active_clients",
  label: "All clients",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_creatives",
  label: "All creatives"
}, {
  field: "active_clients_and_creatives",
  label: "All clients and creatives"
}, {
  field: "active_clients_with_a_draft",
  label: "All clients that have a draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_a_draft_in_subcat",
  label: "All clients that have a draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "active_clients_with_a_non_qualified_draft",
  label: "All clients that have a non-qualified draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_a_non_qualified_draft_in_subcat",
  label: "All clients that have a non-qualified draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "active_clients_without_a_draft",
  label: "All clients that don't have a draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_without_a_draft_in_subcat",
  label: "All clients that don't have a draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "active_clients_that_never_posted_a_project",
  label: "All clients that have never posted a project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_that_never_posted_a_project_in_subcat",
  label: "All clients that have never posted a project in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "active_clients_that_registered_in_past_n_months_and_never_posted_a_project",
  label: "All clients that registered in the past N months and have never posted a project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "n_months",
    type: "number",
    label: "Number of months",
    required: true
  }]
}, {
  field: "active_clients_that_posted_n_projects",
  label: "All clients that have posted N projects",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "n_projects",
    type: "number",
    label: "Number of projects",
    required: true
  }]
}, {
  field: "active_clients_that_posted_n_projects_or_more",
  label: "All clients that have posted N projects or more",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "n_projects",
    type: "number",
    label: "Number of projects",
    required: true
  }]
}, {
  field: "active_clients_that_have_an_open_or_closed_project_without_focus_groups",
  label: "All clients that have an open or closed project without focus groups",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_that_have_an_open_or_closed_project_without_presentations",
  label: "All clients that have an open or closed project without presentations",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_that_have_an_open_or_closed_project_without_collaboration",
  label: "All clients that have an open or closed project without the collaboration feature",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_that_referred_a_friend",
  label: "All clients that referred a friend",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_an_open_project",
  label: "All clients that have an open project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_a_closed_project",
  label: "All clients that have a closed project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_an_awarded_project",
  label: "All clients that have an awarded project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_with_refunded_projects",
  label: "All clients that have at least 1 refunded project",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_clients_who_rated_cs_5_stars",
  label: "All clients that rated crowdspring 5 stars",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }]
}, {
  field: "active_unverified_creatives",
  label: "All creatives that are not verified",
}, {
  field: "active_creatives_with_reputation_below_N",
  label: "All creatives that have a reputation below N",
  extraContext: [{
    name: "reputation",
    type: "number",
    label: "Reputation",
    required: true
  }]
}, {
  field: "active_creatives_with_reputation_above_N",
  label: "All creatives that have a reputation above N",
  extraContext: [{
    name: "reputation",
    type: "number",
    label: "Reputation",
    required: true
  }]
}, {
  field: "active_creatives_approved_to_participate_in_subcat",
  label: "All creatives approved to participate in a given sub-category",
  extraContext: [{
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}];

export const MARKETING_SEGMENT_OPTIONS = [
  { field: 'agency', label: 'Agency' },
  { field: 'top_n_companies', label: 'Top companies' },
  { field: 'business_owner', label: 'Business owner' },
  { field: 'product_entrepreneur', label: 'Product entrepreneur' },
];

export const SINGLE_EMAIL_FORM_NAME = 'singleEmailForm';

export const AUTOMATIONS_RESOURCE_NAME = 'automations';

export const GROUPS_RESOURCE_NAME = 'groups';

export const GROUP_FORM_NAME = 'groupForm';

export const AUTOMATION_FORM_NAME = 'automationForm';

// TODO: update based on backend definitions
export const EVENT_ENTRY_CONDITIONS = [{
  field: "register",
  label: "Register",
}, {
  field: "register_as_client",
  label: "Register as a client",
}, {
  field: "register_as_creative",
  label: "Register as a creative",
}, {
  field: "create_focus_group",
  label: "Create a focus group",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "set_focus_group_open",
  label: "Set a focus group to open",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "create_presentation",
  label: "Create a presentation",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "set_presentation_open",
  label: "Set a presentation to open",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "create_draft",
  label: "Create a draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "create_draft_in_subcat",
  label: "Create a draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "create_qualified_draft",
  label: "Create a qualified draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "create_qualified_draft_in_subcat",
  label: "Create a qualified draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}, {
  field: "create_non_qualified_draft",
  label: "Create a non-qualified draft",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment",
  }]
}, {
  field: "create_non_qualified_draft_in_subcat",
  label: "Create a non-qualified draft in a given sub-category",
  extraContext: [{
    name: "marketing_segment",
    type: "marketing_segment",
    label: "Marketing segment"
  }, {
    name: "sub_category",
    type: "sub_category",
    label: "Sub-category",
    required: true
  }]
}];

export const AUTOMATION_METRICS_FIELDS = [{
  name: 'count_leads_total',
  label: 'Leads',
  alwaysVisible: true
}, {
  name: 'count_targeted_total',
  label: 'Targeted',
  alwaysVisible: true
}, {
  name: 'count_delivered_total',
  label: 'Delivered',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_unique_confirmed_opened_total',
  label: 'Unique opens',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_unique_clicked_total',
  label: 'Unique clicks',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_exited_leads_total',
  label: 'Left',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_goal_1_total',
  label: 'Primary goal',
  showPercentages: true,
  alwaysVisible: true,
  isToggle: true
}, {
  name: 'count_goal_2_total',
  label: 'Goal 2',
  showPercentages: true
}, {
  name: 'count_goal_3_total',
  label: 'Goal 3',
  showPercentages: true
}, {
  name: 'count_goal_4_total',
  label: 'Goal 4',
  showPercentages: true
}];



// WEBPACK FOOTER //
// ./email_automations/constants.js